export const state = () => ({
    integrations: [],
});

export const mutations = {
    setIntegrations(state: any, payload: any) {
        state.integrations = payload;
    },
};

export const getters = {
    getIntegrations: (state: any) => state.integrations,
};

export const actions = {
    async getIntegrations(state: any) {
        const company_uuid = this.$auth.user.company.uuid;

        return new Promise((resolve, reject) => {
            this.$axios
                .get(`/api/company/${company_uuid}/integrations`)
                .then((res) => {
                    state.commit('setIntegrations', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    async updateIntegrations(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            const company_uuid = this.$auth.user.company.uuid;

            this.$axios
                .put(`/api/company/${company_uuid}/integrations`, payload)
                .then(async (res) => {
                    // Fetch the user to refresh the company.
                    await this.$auth.fetchUser();

                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
